"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroCommunicationEvent = void 0;
var MicroCommunicationEvent;
(function (MicroCommunicationEvent) {
    MicroCommunicationEvent["EXTERNAL_CHAT_PARTNER_HELP_CLICKED"] = "external_chat_partner_help_clicked";
})(MicroCommunicationEvent = exports.MicroCommunicationEvent || (exports.MicroCommunicationEvent = {}));
//# sourceMappingURL=event-names.js.map